import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mellify/ui';
import { Plus, Brain } from 'lucide-react';
import { ROUTES } from '../../routes/routeConfig';
import { AIGeneratePersonaModal } from './personas/components/AIGeneratePersonaModal';

const PersonasPageActions: React.FC = () => {
  const navigate = useNavigate();
  const [aiModalOpen, setAiModalOpen] = useState(false);

  return (
    <>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          leftIcon={<Brain className="w-4 h-4" />}
          onClick={() => setAiModalOpen(true)}
        >
          AI Generate
        </Button>
        <Button
          variant="primary"
          size="sm"
          leftIcon={<Plus className="w-4 h-4" />}
          onClick={() => navigate(ROUTES.DASHBOARD_PERSONAS + '/new')}
        >
          Create Persona
        </Button>
      </div>

      <AIGeneratePersonaModal
        open={aiModalOpen}
        onClose={() => setAiModalOpen(false)}
      />
    </>
  );
};

export { PersonasPageActions };
export default PersonasPageActions;